import { type PropsWithChildren, useEffect, useState } from 'react';

import { BridgewayGlyph } from '@/components/BridgewayGlyph';

const QUERY = '(max-width: 768px)';

const useIsMobile = () => {
	const [mobile, setMobile] = useState(() => window.matchMedia(QUERY).matches);
	useEffect(() => {
		const mql = window.matchMedia(QUERY);
		const handler = (e: MediaQueryListEvent) => setMobile(e.matches);
		mql.addEventListener('change', handler);
		return () => mql.removeEventListener('change', handler);
	}, []);
	return mobile;
};

export const MobileBlocker = ({ children }: PropsWithChildren) => {
	const isMobile = useIsMobile();
	if (!isMobile) {
		return <>{children}</>;
	}
	return (
		<div
			className="bg-beacon-ivory flex h-full min-h-screen w-full items-center
				justify-center px-6"
			role="region"
			aria-label="Bridgeway works best on desktop"
		>
			<div className="flex max-w-md flex-col items-center gap-4 text-center">
				<BridgewayGlyph />
				<h1
					className="font-adobe-clean-display text-[28px] leading-[34px]
						font-black text-(--text-primary)"
				>
					Bridgeway works best on desktop
				</h1>
				<p className="text-[16px] leading-[24px] text-(--text-secondary)">
					Open Bridgeway on your desktop to chat, see campaigns, and review your
					content.
				</p>
				<p className="mt-2 text-[14px] text-(--text-muted)">
					Mobile coming soon.
				</p>
			</div>
		</div>
	);
};
